import { z } from "zod";
import { BaseEvent } from "./base";
export const StaticConfigCache_Invalid = BaseEvent.extend({
    name: z.literal("events.superwall.com.feature.StaticConfig.Cache_Invalid"),
    event: z.object({
        application_id: z.number(),
        public_api_key: z.string(),
        uncahed_config: z.string(),
        cached_config: z.string()
    })
});
